// This file contains the data for the "Internships and Post-Graduate Programs" page.
// The data has been updated and greatly expanded from the provided Notion link.

export const programs = [
  // --- Domestic Internships ---
  {
    name: "Summer Research Fellowship Programme (SRFP)",
    institute: "JNCASR, Bangalore",
    type: "Internship",
    time: "Summer",
    link: "https://www.jncasr.ac.in/academic/fandeprogrammes/srfp",
    imageUrl: "https://static.careers360.mobi/media/presets/720X480/colleges/social-media/media-gallery/772/2018/10/25/Campus%20view%20of%20Jawaharlal%20Nehru%20Centre%20for%20Advanced%20Scientific%20Research%20Bangalore_Campus-view.jpg",
    location: "Domestic",
    eligibleYears: [1, 2, 3, 4]
  },
  {
    name: "Visiting Students' Research Programme (VSRP)",
    institute: "TIFR, Hyderabad",
    type: "Internship",
    time: "Summer",
    link: "https://www.tifrh.res.in/academics/vsrp/",
    imageUrl: "https://www.inidesignstudio.com/wp-content/uploads/2024/03/1_22-Photo.jpg",
    location: "Domestic",
    eligibleYears: [2, 3, 4, 5]
  },
  {
    name: "Summer Internship Programme",
    institute: "Physical Research Laboratory, Ahmedabad",
    type: "Internship",
    time: "Summer",
    link: "https://www.prl.res.in/prl-eng/summer_internship",
    imageUrl: "https://www.prl.res.in/prl-eng/sites/default/files/images/slider_images/prl.jpg",
    location: "Domestic",
    eligibleYears: [4, 5]
  },
  {
    name: "Visiting Students Programme (VSP) in Physics",
    institute: "Harish-Chandra Research Institute, Prayagraj",
    type: "Internship",
    time: "TBD",
    link: "https://www.hri.res.in/academics/physics/phy-vsp/",
    imageUrl: "https://th.bing.com/th/id/R.a724adfe4055db82a96f3ea36689761b?rik=SbRLLsmWcAtTpQ&riu=http%3a%2f%2f4.bp.blogspot.com%2f_3erfUD9U_oE%2fS_i5WG61LwI%2fAAAAAAAADHw%2fuE684WhaSJs%2fw1200-h630-p-k-no-nu%2fHRI.1.jpg&ehk=6%2bmKowAHoRxIHSqxE5SCidwiuhuJNM2dVtxEhKEoJC4%3d&risl=&pid=ImgRaw&r=0",
    location: "Domestic",
    eligibleYears: [3, 4, 5]
  },
  {
    name: "Summer School Programme",
    institute: "Indian Institute of Astrophysics, Bangalore",
    type: "Internship",
    time: "Summer",
    link: "https://www.iiap.res.in/opportunities/visiting-students/internships/",
    imageUrl: "https://tse3.mm.bing.net/th/id/OIP.ybIH_Q6wUo6a3o9_rIEL0wHaDr?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    location: "Domestic",
    eligibleYears: [4, 5]
  },
  {
    name: "Summer Students’ Programme",
    institute: "Saha Institute of Nuclear Physics, Kolkata",
    type: "Internship",
    time: "Summer (May-July)",
    link: "https://www.saha.ac.in/web/summer-home",
    imageUrl: "https://tse4.mm.bing.net/th/id/OIP.KnspZmL-77JBMUSUKjMQ2QHaFP?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    location: "Domestic",
    eligibleYears: [4, 5]
  },
  {
    name: "Visiting Student Program (VSP)",
    institute: "Raman Research Institute, Bangalore",
    type: "Internship",
    time: "Year-round",
    link: "https://www.rri.res.in/careers/visiting-students",
    imageUrl: "https://vajiramandravi.com/current-affairs/wp-content/uploads/2025/04/rri.webp",
    location: "Domestic",
    eligibleYears: [2, 3, 4, 5]
  },
  {
    name: "Summer Research Programme",
    institute: "The Institute of Mathematical Sciences, Chennai",
    type: "Internship",
    time: "Summer",
    link: "https://www.imsc.res.in/summer_research_programmer",
    imageUrl: "https://cdn.thewire.in/wp-content/uploads/2019/12/24083911/matscience-chennai.jpg",
    location: "Domestic",
    eligibleYears: [2, 3, 4]
  },
  {
    name: "Vacation Students' Programme (VSP)",
    institute: "IUCAA, Pune",
    type: "Internship",
    time: "Summer",
    link: "https://www.iucaa.in/en/education/summer-winter-programmes",
    imageUrl: "https://i0.wp.com/www.tusktravel.com/blog/wp-content/uploads/2023/06/IUCAA-Pune-Maharashtra.jpg?w=1200&ssl=1",
    location: "Domestic",
    eligibleYears: [3, 4]
  },
  {
    name: "LIGO SURF Program",
    institute: "Caltech, USA (via IUCAA)",
    type: "Internship",
    time: "Summer (May-July)",
    link: "https://www.gw.iucaa.in/ligo-surf-program/",
    imageUrl: "https://www.sciencenews.org/wp-content/uploads/2017/08/080117_EV_ticker_virgo_free.jpg",
    location: "International",
    eligibleYears: [2, 3, 4]
  },
  // --- International Internships ---
  {
    name: "University of Tokyo Research Internship (UTRIP)",
    institute: "The University of Tokyo, Japan",
    type: "Internship",
    time: "Summer",
    link: "https://www.s.u-tokyo.ac.jp/en/utrip/",
    imageUrl: "https://www.kanpai-japan.com/sites/default/files/styles/gallery_square_sm/public/uploads/2024/03/tokyo-daigaku-12.jpg",
    location: "International",
    eligibleYears: [2, 3]
  },
  {
    name: "Scientific Internships (Year-Round)",
    institute: "https://ist.ac.at/en/education/internship-and-scholarship/",
    type: "Internship",
    time: "Year-round",
    link: "https://phd.pages.ist.ac.at/scientific-internships/",
    imageUrl: "https://www.vindobona.org/images/text/ist-institute-of-science-and-technology-austria-2010-big.jpg",
    location: "International",
    eligibleYears: [1, 2, 3, 4, 5]
  },
  {
    name: "ASTRON/JIVE Summer Student Programme",
    institute: "ASTRON, Netherlands",
    type: "Internship",
    time: "Summer",
    link: "https://www.astron.nl/education/summer-research-programme/",
    imageUrl: "https://www.makeitinthenorth.nl/content/uploads/sites/2/2022/11/astron-1.jpg",
    location: "International",
    eligibleYears: [3, 4, 5]
  },
  // --- Masters / PhD / PG ---
  {
    name: "Perimeter Scholars International",
    institute: "Perimeter Institute, Canada",
    type: "Masters",
    time: "Year-round",
    link: "https://perimeterinstitute.ca/training/masters-program/psi-how-apply",
    imageUrl: "https://images.adsttc.com/media/images/500f/1732/28ba/0d0c/c700/1a62/slideshow/stringio.jpg?1414331003",
    location: "International",
    eligibleYears: [4, 5]
  },
  {
    name: "Integrated PhD Program",
    institute: "IISc Bangalore",
    type: "Integrated PhD",
    time: "Year-round",
    link: "https://physics.iisc.ac.in/academics/degree-programs/",
    imageUrl: "https://tse2.mm.bing.net/th/id/OIP.5cfjsi0h20OXsPVpuxdpBwHaEK?cb=12&w=1280&h=720&rs=1&pid=ImgDetMain&o=7&rm=3",
    location: "Domestic",
    eligibleYears: [3, 4]
  },
  {
    name: "PhD Program",
    institute: "Max Planck Institutes, Germany",
    type: "PhD",
    time: "Year-round",
    link: "https://www.mpg.de/en/imprs",
    imageUrl: "https://www.imprs-trust.mpg.de/files/2017/12/2-Geb%C3%A4ude-1024x683.jpg",
    location: "International",
    eligibleYears: [5]
  },
  {
    name: "ICTP Postgraduate Diploma Programme",
    institute: "ICTP, Italy",
    type: "Post-Graduate Diploma",
    time: "Year-round",
    link: "https://www.ictp.it/opportunity/ictp-postgraduate-diploma-programme",
    imageUrl: "https://www.intrieste.com/w/wp-content/uploads/2020/05/ictp.jpg",
    location: "International",
    eligibleYears: [4, 5]
  }
];

